module.exports = __webpack_public_path__ + "img/flower_leaf_27.53032e29.png";